import React from 'react'
import './Success_Toster.css'

const Success_Toster = ({successText}) => {
  
  return (
    <section className='Success_Toster'>
        <div className='img_holder'>
            <img src={process.env.PUBLIC_URL + "/assets/images/other/checkmark.png"} className='inner_img'/>
        </div>
        <p className='success_txt'>{successText}</p>
    </section>
  )
}

export default Success_Toster
